import React from "react";
import { Sun, Moon, LogOut } from "./Icons";
import { initials } from "../lib/format";
import { LABEL } from "../density";

export const TABS = [
  { key: "labour",       label: "Dashboard" },
  { key: "pl",           label: "P&L" },
  { key: "expenses",     label: "Expenses" },
  { key: "receivables",  label: "Receivables" },
  { key: "unbilled",     label: "Unbilled" },
  // Sensitive, but grantable: page access decides, not the fd login.
  { key: "equity",       label: "Equity" },
  { key: "projects",     label: "Project" },
  { key: "admin",        label: "Admin", fdOnly: true },
];

export default function Shell({
  username, activeTab, setActiveTab, theme, onToggleTheme, onLogout, pages,
  density, children,
}) {
  const isFD = (username || "").toUpperCase() === "FD";

  // pages = null means no restrictions (see all)
  const visibleTabs = TABS.filter((t) => {
    if (t.fdOnly) return isFD;
    if (!pages) return true;
    return pages.includes(t.needs || t.key);
  });

  /*
   * fd's job is the admin one - users, imports, the journal, prepaid - so Admin
   * leads for them rather than sitting last behind nine partner pages. Everyone
   * else keeps the order above, which runs from the everyday to the occasional.
   */
  if (isFD) {
    visibleTabs.sort((a, b) => (b.key === "admin") - (a.key === "admin"));
  }

  return (
    <div className="app">
      <header className="topbar">
        <div className="brand">
          <span className="brand-mark" aria-hidden>D</span>
          <span>
            <div className="brand-name">Diligence</div>
            <div className="brand-sub">Partner dashboard</div>
          </span>
        </div>

        <nav className="nav" aria-label="Sections">
          {visibleTabs.map((t) => (
            <button
              key={t.key}
              className={`nav-item${activeTab === t.key ? " is-active" : ""}`}
              aria-current={activeTab === t.key ? "page" : undefined}
              onClick={() => setActiveTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </nav>

        <div className="spacer" />

        {density && (
          <div className="density" role="group" aria-label="Display size">
            <button
              className="density-btn"
              onClick={density.smaller}
              disabled={!density.canShrink}
              title={`Smaller text and tighter columns (${LABEL[density.density]})`}
              aria-label="Decrease display size"
            >
              A<span className="density-sign">−</span>
            </button>
            <span className="density-level" title={LABEL[density.density]}>
              {LABEL[density.density]}
            </span>
            <button
              className="density-btn density-btn--lg"
              onClick={density.bigger}
              disabled={!density.canGrow}
              title={`Larger text (${LABEL[density.density]})`}
              aria-label="Increase display size"
            >
              A<span className="density-sign">+</span>
            </button>
          </div>
        )}

        <button
          className="icon-btn"
          onClick={onToggleTheme}
          title={theme === "dark" ? "Switch to light" : "Switch to dark"}
          aria-label="Toggle colour theme"
        >
          {theme === "dark" ? <Sun /> : <Moon />}
        </button>

        <div className="user-chip" title={`Signed in as ${username}`}>
          <span className="avatar" aria-hidden>{initials(username)}</span>
          <span className="user-name">{String(username || "").toUpperCase()}</span>
        </div>

        <button className="icon-btn" onClick={onLogout} title="Sign out" aria-label="Sign out">
          <LogOut />
        </button>
      </header>

      {children}
    </div>
  );
}
